import { axiosInstance } from '~/api/config/axios.config';
import { conformObjectResponse } from '~/api/utils';
import { UserProfile } from '~/models/profile/UserProfile.dto';

export class ProfileApi {

    static async getUserProfile() {
        return conformObjectResponse(axiosInstance.get('/catalogue/projectCreator/userProfile'), UserProfile);
    }

    static async updateProfile(data: UserProfile) {
        return conformObjectResponse(axiosInstance.put('/catalogue/projectCreator/userProfile/save', { ...data }), UserProfile);
    }
}